import React, { useMemo, memo, useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';

import '../../../css/components/batches/DetailsVehicleCard.css';

import Traductor from '../../Traductor';
import { getImageSource } from '../../../Functions';
import DetailsPriceForm from './DetailsPriceForm.js';

import {
    formatNumber,
    formatDate,
} from '../../../js/components/shared/vehicleFunctions';

const DetailsVehicleCard = ({
    loading,
    disabled,
    AmountOffered,
    AmountReference,
    Brand,
    IdVehicle,
    IdPublish,
    Model,
    Origin,
    Plate,
    Frame,
    ImageSource,
    onVehicleCardPress,
    onDelete,
    onChangeAmount,
    inputAmount,
    batchStatus,
    Km,
    CV,
    Energy,
    RegistrationDate,
    Transmission,
    LastAmount,
}) => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const t = useMemo(() => new Traductor(), []);

    const printDetails = useCallback(() => {
        return (
            <ul
                className={`c-vehicle-card__options-list u-m-none u-font-initial u-mb-small ${
                    isMobile ? 'u-text-fs-3' : 'u-text-fs-1'
                }`}
            >
                {RegistrationDate && (
                    <li>{formatDate(RegistrationDate, false)} </li>
                )}
                {Km && <li>{formatNumber(Km)} Km </li>}
                {CV && <li>{CV} CV </li>}
                {Energy && <li>{Energy} </li>}
                {Transmission && <li>{Transmission}</li>}
            </ul>
        );
    }, [CV, Energy, Km, RegistrationDate, Transmission, isMobile]);

    const onClick = useCallback(() => {
        onVehicleCardPress({
            IdVehicle,
            Origin: { Description: Origin },
            IdPublish,
            batchStatus,
            AmountOffered,
            AmountReference,
            LastAmount,
            Frame,
            Plate,
        });
    }, [
        onVehicleCardPress,
        IdVehicle,
        Origin,
        IdPublish,
        batchStatus,
        AmountOffered,
        AmountReference,
        LastAmount,
        Frame,
        Plate,
    ]);

    return (
        <article
            className={`c-card o-layout__item u-1/1 ${
                loading ? 'skeleton-details-card' : ''
            }`}
            style={{ flexDirection: 'row' }} //fix styles for Internet Explorer
        >
            <div className="c-card__body">
                <div className="o-layout  o-layout--divider">
                    <div
                        id="c-vehicle-details-container"
                        className="o-layout__item  u-2/3  u-1/1@m u-p-none u-pl u-pb"
                    >
                        <section
                            className="c-media-teaser o-layout u-p-none u-m-none"
                            style={{ display: 'flex' }}
                        >
                            <div
                                className={`c-media-teaser__media u-1/3 u-2/5@s`}
                                style={{
                                    flexBasis: 'initial',
                                    cursor: 'pointer',
                                }}
                                onClick={onClick}
                            >
                                {loading ? (
                                    <img
                                        /*src={NoImagePNG}
                                        sizes="100vw"*/
                                        alt=""
                                    />
                                ) : (
                                    <img
                                        className="c-media-teaser__image js-object-fit"
                                        src={getImageSource(ImageSource)}
                                        sizes="100vw"
                                        alt={`car.Model.Description`}
                                    />
                                )}
                            </div>
                            <div className=" u-2/3 u-3/5@s c-media-teaser__caption u-p-none u-pl u-pb-none">
                                <div>
                                    <p
                                        className="c-media-teaser__title u-mb-none u-h5"
                                        onClick={onClick}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {!loading &&
                                            `${Brand?.Description || Brand} ${
                                                Model.Description
                                            } - ${Plate}`}
                                    </p>
                                    <div className="c-media-teaser__body">
                                        <p className="u-h6 u-font-initial u-mb-small u-text-truncate">
                                            {!loading &&
                                                Model?.DescriptionLong?.replace(
                                                    Model.Description,
                                                    ''
                                                )}
                                        </p>
                                        {!loading && printDetails()}
                                        {!isMobile ? (
                                            loading ? (
                                                <div className="skeleton-details-button u-1/4" />
                                            ) : (
                                                Origin && (
                                                    <div className="o-inline-group u-p-none u-m-none u-mb u-initial-button u-mv u-flex">
                                                        <p
                                                            className="u-text-brand u-text-fs-2 u-flex"
                                                            //fixes and centers truncate the text
                                                            style={{
                                                                fontWeight: 700,
                                                                flex: 1,
                                                                minWidth: 0,
                                                            }}
                                                        >
                                                            <i className="c-btn__icon c-icon  c-icon--[semantic-location] c-icon--xxsmall u-text-brand" />
                                                            <span className="u-text-truncate">
                                                                {Origin}
                                                            </span>
                                                        </p>
                                                    </div>
                                                )
                                            )
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                                <div className="u-2/3 c-media-teaser__footer">
                                    {onDelete ? (
                                        loading ? (
                                            <div className="skeleton-details-button" />
                                        ) : (
                                            <button
                                                className="c-btn o-inline-group u-p-none u-m-none u-animated-outline-container u-pr-xsmall"
                                                onClick={() =>
                                                    onDelete({
                                                        IdPublish,
                                                        AmountOffered,
                                                        batchStatus,
                                                        AmountReference,
                                                    })
                                                }
                                                tabIndex="-1"
                                            >
                                                <i className="c-btn__icon c-icon c-icon--[bin] c-icon--xxsmall u-mr-xxsmall" />
                                                <p className="u-text-brand u-text-fs-2 u-animated-outline-item">
                                                    {t.getTraduction('Delete')}
                                                </p>
                                            </button>
                                        )
                                    ) : null}
                                </div>
                            </div>
                        </section>
                    </div>
                    <DetailsPriceForm
                        loading={loading}
                        disabled={disabled}
                        onChangeAmount={onChangeAmount}
                        inputAmount={inputAmount}
                        vehicle={{
                            IdVehicle,
                            IdPublish,
                            batchStatus,
                            AmountOffered,
                            AmountReference,
                            LastAmount,
                        }}
                        containerClasses={'u-1/3  u-1/1@m u-mt-none@s u-pl'}
                    />
                </div>
            </div>
        </article>
    );
};

DetailsVehicleCard.propTypes = {
    loading: PropTypes.any,
    AmountOffered: PropTypes.number,
    AmountReference: PropTypes.number,
    Brand: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    IdVehicle: PropTypes.number,
    IdPublish: PropTypes.number,
    Model: PropTypes.shape({
        Description: PropTypes.string.isRequired,
        DescriptionLong: PropTypes.string.isRequired,
    }),
    Origin: PropTypes.string,
    Plate: PropTypes.string,
    ImageSource: PropTypes.string,
    onVehicleCardPress: PropTypes.func,
    onDelete: PropTypes.func,
    onChangeAmount: PropTypes.func,
    inputAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    batchStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Km: PropTypes.number,
    CV: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Energy: PropTypes.string,
    RegistrationDate: PropTypes.string,
    Transmission: PropTypes.string,
    LastAmount: PropTypes.number,
};

export default memo(DetailsVehicleCard);
